import * as React from 'react';
import { connect } from 'react-redux';
import { AxiosResponse } from 'axios';
import * as _ from 'lodash';
import { push } from 'connected-react-router';

import {
    Project,
    PROJECT_STATUS,
    TENANT_LEVEL,
    PanelType
} from '@nexxt/common/types';

import * as projectService from '../../../services/project.service';
import * as Action from '../../../actions/project.actions';
import NotifyHOC from '../../../HOC/Notifications';
import { alertMessage } from '../../../constants/alertMessage';
import config from '../../../config';
import { IApplicationState } from '../../../reducers';
import {
    INCA_DEMO_BOOK_URL,
    STATIC_STORAGE_URL
} from '@nexxt/common/constants';
import {
    EDIT_NEW_PROJECT,
    MAIN_ROUTE,
    PREVIEW
} from '../../../constants/routes';
import { interpolate } from '../../../utils/string';
import { LinkGenerator } from '../../common/LinkGenerator';
import { getTenantLevel } from '@nexxt/common/firebase/auth/userDetails';
import { packagedSolution } from '../../../mapping/project';

interface LaunchModalProps {
    // onClose: () => void;
    user: any;
    currentProject: Project;
    toastNotification: any;
    location: any;
    match: any;
    changePath: (path: string) => void;
    setProject: (newProject: Project) => void;
    clearProjects: () => void;
}
interface LaunchModalState {
    chatbotURL: string;
    projectId: number;
}
class LaunchModal extends React.Component<LaunchModalProps, LaunchModalState> {
    constructor(props) {
        super(props);
        /**
         * Temporary add the list in localstorage
         */
        this.state = {
            chatbotURL: '',
            projectId: -1
        };
    }

    componentWillUnmount() {
        this.props.clearProjects();
    }
    async componentDidMount() {
        if (_.isEmpty(this.props.currentProject)) {
            await this.fetchProjectById();
        }
        // If proj status !== REVIEW then we must call API to generate codename
        // Add here
        const projectId = this.props.currentProject.id;
        const baseURL = config.host.bot + '/p/';
        this.setState({
            chatbotURL:
                this.props.currentProject.status === PROJECT_STATUS.REVIEW
                    ? baseURL + projectId + '_PREVIEW'
                    : baseURL + this.props.currentProject.codeName,
            projectId: projectId
        });
    }

    fetchProjectById = async () => {
        try {
            const projectID = parseInt(this.props.match.params.projectId);
            const response: AxiosResponse = await projectService.fetchProject(
                projectID // change this to fetch by another method if has issue in future
            );
            const projectData = response.data.data;

            if (projectData.status !== PROJECT_STATUS.LIVE) {
                this.props.toastNotification.error(
                    alertMessage.ASK_PROJECT_LAUNCH
                );
                this.props.changePath(
                    interpolate(EDIT_NEW_PROJECT, { projectId: projectID })
                );
            }

            this.props.setProject(projectData);
        } catch (error) {
            this.props.toastNotification.error(
                alertMessage.UNABLE_FETCH_PROJECT
            );
        }
    };

    render() {
        const { chatbotURL } = this.state;
        const { toastNotification, currentProject, location } = this.props;
        const purchaseID = location?.state?.purchaseID;
        const tenantLevel = getTenantLevel();
        const incaPanel =
            currentProject?.panelSettings?.panelType === PanelType.INCA;
        const forceTestMode = incaPanel;
        const hidePanel = incaPanel;
        const isWizard = tenantLevel === TENANT_LEVEL.INCA_WIZARD;
        const isSandbox = tenantLevel === TENANT_LEVEL.SANDBOX;
        const isSelfService = tenantLevel <= 1 || isWizard;
        const rapidSolution = packagedSolution.find(
            (solution) =>
                location.state?.solution?.projectID === solution.projectID
        );
        const redirectLink = isWizard
            ? `${config.host.bot}/p/${currentProject.codeName}?TERMINATE=cta&testMode=true`
            : `${config.host.dashboard}/p/${currentProject.codeName}`;
        const dashboardLink = isWizard
            ? `${config.host.dashboard}/p/${rapidSolution?.codename}/reports`
            : `${config.host.dashboard}/p/${currentProject.codeName}/reports`;
        if (isWizard) {
            return (
                <div className="setup-wizard--container">
                    <div className="setup-wizard--question">
                        <span className="setup-wizard--question--content">
                            And...lift off!
                        </span>
                    </div>
                    <img
                        className="setup-wizard--body--launch--img"
                        src={`${STATIC_STORAGE_URL}/img/portal/illustrates/rocket.gif`}
                    />
                    <div className="setup-wizard--body--launch">
                        <span className="setup-wizard--body--launch--subheader">
                            Your test project is ready.
                        </span>
                        <p>
                            Chat with inca to see it in action. You can also use
                            the link below to share your project with your
                            colleagues. Please note we do not support live
                            dashboards for test projects.
                        </p>
                        <div className="setup-wizard--body--launch--link">
                            <LinkGenerator
                                toastNotification={toastNotification}
                                chatbotURL={`${chatbotURL}?TERMINATE=cta`}
                                currentProject={currentProject}
                                hidePanel={isWizard}
                                forceTestMode
                                hideTitle
                            />
                        </div>
                    </div>
                    <div className="setup-wizard--actions">
                        <button
                            type="button"
                            className="btn btn--sm btn--green"
                            onClick={() => window.location.assign(redirectLink)}
                        >
                            Go to Your Chat
                        </button>
                        <button
                            type="button"
                            className="btn btn--sm btn--green ml-2"
                            onClick={() =>
                                window.location.assign(dashboardLink)
                            }
                        >
                            Go to Demo Dashboard
                        </button>
                    </div>
                </div>
            );
        } else if (isSandbox) {
            return (
                <div className="setup-wizard--container">
                    <div className="setup-wizard--question">
                        <span className="setup-wizard--question--content">
                            Almost there!
                        </span>
                    </div>
                    <img
                        className="setup-wizard--body--launch--img"
                        src={`${STATIC_STORAGE_URL}/img/portal/illustrates/rocket.gif`}
                    />
                    <div className="setup-wizard--body--launch">
                        <span className="setup-wizard--body--launch--subheader">
                            Your project is being reviewed
                        </span>
                        <p>
                            Your account manager will contact you in the next
                            24hrs after reviewing your project.
                        </p>
                        <p>
                            Chat with inca to see it in action. You can also use
                            the link below to share your project with your
                            colleagues.
                        </p>
                        <div className="setup-wizard--body--launch--link">
                            <LinkGenerator
                                toastNotification={toastNotification}
                                chatbotURL={chatbotURL}
                                currentProject={currentProject}
                                hidePanel={isSandbox}
                                forceTestMode
                                hideTitle
                            />
                        </div>
                    </div>
                    <div className="setup-wizard--actions">
                        <button
                            type="button"
                            className="btn btn--sm btn--green"
                            onClick={() => {
                                this.props.changePath(
                                    interpolate(PREVIEW, {
                                        projectId: this.state.projectId
                                    })
                                );
                            }}
                        >
                            Go to Your Chat
                        </button>

                        <button
                            type="button"
                            className="btn btn--sm btn--green"
                            onClick={() => {
                                this.props.changePath(MAIN_ROUTE);
                            }}
                        >
                            Return to Home
                        </button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="project-launch--container">
                    <div className="project-launch--link__container">
                        <div className="project-launch--link__header">
                            <img
                                src={`${STATIC_STORAGE_URL}/img/portal/illustrates/blue-bird.png`}
                            />
                            <img
                                className="project-launch--link__header-congrats left"
                                src={`${STATIC_STORAGE_URL}/img/portal/illustrates/launch-congrats.png`}
                            />
                            <img
                                className="project-launch--link__header-congrats right"
                                src={`${STATIC_STORAGE_URL}/img/portal/illustrates/launch-congrats.png`}
                            />
                            <p className="project-launch--link__header-title">
                                Hooray!
                            </p>
                            <p className="project-launch--link__header-subtitle">
                                You have successfully launched
                                <br />
                                <span>{currentProject.name}</span>.
                            </p>
                            <p>
                                {isSelfService
                                    ? "Now it's time to share it!"
                                    : 'Now you can sit back and relax!'}
                            </p>
                        </div>
                        {(isSelfService || isWizard) && (
                            <LinkGenerator
                                toastNotification={toastNotification}
                                chatbotURL={
                                    isWizard
                                        ? `${chatbotURL}?TERMINATE=cta`
                                        : chatbotURL
                                }
                                currentProject={currentProject}
                                hidePanel={hidePanel}
                                forceTestMode={forceTestMode}
                            />
                        )}

                        <div className="project-launch--link__footer">
                            {!isWizard ? (
                                <>
                                    <p className="project-launch--link__footer-title">
                                        Access all the insights through the
                                        Dashboard.
                                    </p>
                                    <p className="project-launch--link__footer-subtitle">
                                        You might not see anything right away,
                                        check back in after a couple hours. Be
                                        sure to share your project first.
                                    </p>
                                </>
                            ) : (
                                <p
                                    className="project-launch--link__footer-title"
                                    style={{ margin: '40px 0px' }}
                                >
                                    {
                                        'To unlock response data and see all the other capabilities of inca, please book a demo with us!'
                                    }
                                </p>
                            )}

                            <button
                                type="button"
                                className="btn btn--lg btn--blue"
                                onClick={() =>
                                    window.location.assign(redirectLink)
                                }
                            >
                                {isWizard ? 'Go to Survey' : 'Go to Dashboard'}
                            </button>
                            {isWizard && (
                                <button
                                    type="button"
                                    className="btn btn--lg btn--blue ml-2"
                                    onClick={() =>
                                        window.location.assign(
                                            INCA_DEMO_BOOK_URL
                                        )
                                    }
                                >
                                    Book a Demo
                                </button>
                            )}
                            {purchaseID && (
                                <p className="project-launch--link__footer-footer">
                                    Purchase Reference #{purchaseID}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject },
        authReducer: { user }
    } = store;
    return {
        currentProject,
        user
    };
};

const mapDispatchToProps = (dispatch) => ({
    setProject: (newProject: Project) => {
        dispatch(Action.setProject(newProject));
    },
    clearProjects: () => dispatch(Action.clearProjects()),
    changePath: (path) => {
        dispatch(push(path));
    }
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(LaunchModal)
);
